export const CINEMA_UI_URL = process.env.REACT_APP_CINEMA_UI_URL
export const QW_INBOX_API_URL = process.env.REACT_APP_QW_INBOX_API_URL
export const ZIPPO_URL = process.env.REACT_APP_ZIPPO_URL
export const DEVICE_MANAGER_ROLE = process.env.REACT_APP_DEVICE_MANAGER_ROLE
export const REFETCH_COMPOSITION_TIME = process.env.REACT_APP_REFETCH_COMPOSITION_TIME_SEC
export const UPDATE_REFETCH_TIMEOUT = process.env.REACT_APP_UPDATE_REFETCH_TIMEOUT_SEC
export const MONARCH_URL = process.env.REACT_APP_MONARCH_API_URL



// WEBPACK FOOTER //
// ./src/app/common/config.js